import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { Reveal } from './Reveal';
export function PainPoints() {
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="dolor-title" data-id="element-178" data-mp="2lpeuecmv95yb">
      <div className="mx-auto max-w-6xl px-6" data-id="element-179" data-mp="26y60vsfuf0fw">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1fr)] lg:gap-20" data-id="element-180" data-mp="2bwzd7hje8leh">
          <Reveal data-id="element-181" data-mp="1xx85tzndu39g">
            <h2 id="dolor-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-182" data-mp="1xwon4gpwraud">
              Si tenes dolores de cabeza/migraña, inchason de manos/pies/cara o inchason abdominal
              <span className="block text-mint-700" data-id="element-183" data-mp="1o14sdxn2yi77">Te recomiendo este Megapack!</span>
            </h2>
            <p className="mt-6 max-w-md text-lg text-ink-soft" data-id="element-184" data-mp="1sz6kt96ebtvc">
              De forma inmediata recibirás un correo electrónico de confirmación con el acceso
            </p>
            <p className="mt-8 font-display text-2xl text-ink sm:text-[1.75rem]" data-id="element-185" data-mp="3nbmp44fmsxxk">
              ¿Cuántas mañanas más vas a despertar con el intestino inflamado y sin saberlo es el problema a todos tus males?
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-186" data-mp="1tzhjoow7uo81">
            <ul className="divide-y divide-mint-100 border-y border-mint-100" data-id="element-187" data-mp="27ti9uu93r2ws">
              {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-5" data-id="element-188" data-mp="23qvggows99xh">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-700" aria-hidden="true" data-id="element-189" data-mp="1g1szlj9z3l41">
                    <XIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-190" data-mp="1b4164ktojqxq" />
                  </span>
                  <span className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-191" data-mp="1p3k0matkj3rk">
                    {point}
                  </span>
                </li>)}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}